import { storageKeys } from "@/models/constants";

//Don't expose this, it can be accessed through getters and setters
const tokenStorage = localStorage;
export const stateStorage = sessionStorage;

export const storageService = {
	setItemWithExpiration(key: string, value: string, storage = tokenStorage, ttl = 1500000): void {
		const now = new Date();
		const item = {
			value: value,
			expiry: now.getTime() + ttl,
		}

		storage.setItem(key, JSON.stringify(item));
	},
	getItemWithExpiration(key: string, storage = tokenStorage): string {
		const itemStr = storage.getItem(key)
		// if the item doesn't exist
		if (!itemStr) {
			return "";
		}
		try {
			const item = JSON.parse(itemStr)
			const now = new Date();
			// compare the expiry time of the item with the current time
			if (now.getTime() > item.expiry) {
				// If the item is expired, delete the item from storage
				storage.removeItem(key)
				return "";
			}
			return item.value;
		} catch (err: any) {
			storage.removeItem(key)
			return "";
		}
	},
	setToken(value: string): void {
		this.setItemWithExpiration(storageKeys.token, value);
	},
	getToken(): string {
		return this.getItemWithExpiration(storageKeys.token);
	},
	removeToken(): void {
		tokenStorage.removeItem(storageKeys.token);
	},
	clearAll(): void {
		tokenStorage.clear();
		stateStorage.clear();
	}
}